import { IoChevronBack, IoChevronForward, IoClose } from "react-icons/io5";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { Analytics,Gtag } from '../compornents/Analytics';
import { CalcGoukei, ConfirmOption } from '../compornents/CalcGoukei';
import { Post } from '../compornents/Post';
import {
  Checkbox,
  LABEL_PLACEMENT
} from "baseui/checkbox";

export const OptionCategory = () => {
  const navigate = useNavigate();
  let location = useLocation();
  let [data, setData] = useState(location.state.data);
  // console.log(data);
  let [syoukei, setSyoukei] = useState(0);
  let [goukei, setGoukei] = useState(0);
  const [checked, setChecked] = useState(0);

  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });
  const [NotificationModal, openNotificationModal, closeNotificationModal] = useModal('root', {});
  // 戻る
  const back = () => {
    navigate("/home");
  };

  // ホームへ
  const toHome = () => {
    navigate("/home");
  };

  // オプションカテゴリ選択。配下が1件だけなら一覧をスキップして詳細へ直接遷移。
  function selectOptionCategory(option_category) {
    const opts = option_category?.options || [];
    if (opts.length === 1) {
      navigate("/option", { state: { data:data, option_category:option_category, option:opts[0], skipList:true } });
    } else {
      navigate("/options", { state: { data:data, option_category:option_category } });
    }
  };

  // 確認へ
  function nextConfirm(){
    navigate("/confirm", { state: { data:data, from: "option_category" } });
  }

  const calcGoukei = CalcGoukei(data, setSyoukei, setGoukei);
  // 確認へ
  async function changeFlag(checked){
    setChecked(checked);
    const request_data = {'type':'is_option_modal_view','value':checked?1:0};
    let response = await Post('post', '/customer/set_flag.php', request_data);
    let customer = response.customer;
    const newData = { ...data, customer };
    setData(newData);
    // console.log(newData);
    // console.log(newData.user_dropoff_type);
  }

  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    Gtag('view_option_category');
    if (location.state === null || location.state.data === undefined) {
      navigate("/home");
    }
    // 合計金額計算
    calcGoukei();
    // 専用バッグのモーダル
    if(data?.customer?.is_option_modal_view === "0"){
      openNotificationModal();
      let customer = data.customer;
      customer.is_option_modal_view = "1";
      const newData = { ...data, customer };
      setData(newData);
    }
    // 注文情報取得
  }, [calcGoukei, openLoadingModal, closeLoadingModal,location, navigate,openNotificationModal,data]);

  // カテゴリの代表画像＝カテゴリ自身の画像を優先、無ければ配下オプション先頭の画像。
  const catImage = (cat) => {
    const first = (cat.options || []).find((o) => o.img && Number(o.is_not_picture) !== 1);
    return cat.img || first?.img || '';
  };

  // 横長バナー型カード。画像があれば幅いっぱいに表示し、下に分類名・説明を置く。
  const listOptionCategories = data.option_categories.length > 0 ? data.option_categories.map((option_category,key) => {
    const img = catImage(option_category);
    return (
      <div
        className="div_btn"
        onClick={() => selectOptionCategory(option_category)}
        key={key}
        style={{ marginBottom: 16, borderRadius: 14, overflow: 'hidden', border: '1px solid #ececec', background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,.06)' }}
      >
        {img && (
          <img src={img} alt={option_category.name} style={{ width: '100%', height: 130, objectFit: 'cover', display: 'block' }} />
        )}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', gap: 10 }}>
          <div style={{ minWidth: 0 }}>
            {/* 画像に分類名が入っているため、画像があるカテゴリは名称テキストを省略（重複回避）。説明のみ表示。 */}
            {!img && <div className="h5" style={{ margin: 0 }}>{option_category.name}</div>}
            {option_category.explanation && (
              <div style={!img ? { marginTop: 2 } : {}}><small>{option_category.explanation}</small></div>
            )}
          </div>
          <IoChevronForward style={{ color: '#757575', fontSize: '1.3rem', flex: '0 0 auto' }} />
        </div>
      </div>
    );
  }) : (<div>オプションはありません</div>);
  return (
    <div className="App2">
      <div className="Confirm">
        <Analytics title="オプションの追加" />
        <div className="toolbar">
          <div className="toolbar_left">
            <div className="">
              <IoChevronBack onClick={back} />
            </div>
          </div>
          <div className="toolbar_center">
            オプションの追加
          </div>
          <div className="toolbar_right">
            <IoClose onClick={toHome} />
          </div>
        </div>
        <div className="mb-2 border-bottom"></div>
        <div className="content">
          <div>
            {listOptionCategories}
          </div>
          <div className="text-gray-dark">
            <small>※各種加工は、ご依頼品によって加工対象外となる場合がございます（その際は、加工料金相当分のクーポンを発行させていただきます）</small>
          </div>
        </div>

        <div className="flex_div3 border-top">
          <div className="explain">
            {ConfirmOption(data, syoukei, goukei)}
          </div>
          <div className="p-3 pb-4">
            <button className="btn btn-oval btn-yellow form-control" onClick={nextConfirm}>注文内容の確認へ</button>
          </div>
        </div>
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div >
              <TailSpin stroke="#000" />
            </div>
            <div className="">
              <div className="">
                処理中です
              </div>
            </div>
          </div>
        </LoadingModal>

        <NotificationModal>
          <div className="modal rounded p-4" style={{ position: 'relative', paddingTop: '2.5rem' }}>
            <IoClose
              onClick={closeNotificationModal}
              className="h2 text-gray-dark"
              style={{ position: 'absolute', top: '0.5rem', right: '0.5rem', cursor: 'pointer' }}
            />
            <div className="mb-2">
              <div className="h5 text-center mb-2">
                専用バッグ1袋に衣類を<br/>お入れください
              </div>
            </div>
            <div>
              <div className="row mb-2">
                <div className="col-12">
                  <img src="./img/img12.png" alt="DeliveryImage" className="ItemImage" />
                </div>
              </div>
              <div className="mb-2 text-left">
                <ul style={{paddingLeft:'20px'}}>
                  <li>コースの点数を超える場合は、追加依頼品のオプションをご選択ください</li>
                  <li>点数に満たなくても、専用バッグ1袋に収まらない場合はお受けできません</li>
                  <li>点数に満たない場合でも、返金はできかねますのでご了承ください</li>
                </ul>
              </div>
              <div className="mb-4">
                <button className="btn btn-oval btn-yellow form-control" onClick={closeNotificationModal}>OK</button>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Checkbox
                  checked={checked}
                  onChange={e => changeFlag(e.target.checked)}
                  labelPlacement={LABEL_PLACEMENT.right}
                >
                  次回から表示しない
                </Checkbox>
              </div>
            </div>
          </div>
        </NotificationModal>
      </div>

    </div>
  );
}
